<template>
    <form-row title="Filtration Pond" :label_align_top="true" class="pt-0">
        <div class="w-full flex flex-col">
            <input-radio-boolean
                name="has_filtration_pond"
                v-model="has_filtration_pond"
                true="Yes"
                false="No"
                class="pt-2"
                :read_only="read_only"
            />

            <div v-if="has_filtration_pond" class="pt-6 pb-2">
                <input-radio-multi
                    label="Location"
                    name="utilities_water_filtration_pond"
                    :value="commercial.utilities_water_filtration_pond"
                    :options="[
                        { label: 'On-Site', value: 'on-site' },
                        { label: 'Regional', value: 'regional' },
                    ]"
                    :nullable="true"
                    :read_only="read_only"
                />

                <buyer-seller-split
                    label="Who is Responsible for Construction Costs?"
                    class="mt-5"
                    field="utilities_water_filtration_pond_who_responsible"
                    :value="commercial.utilities_water_filtration_pond_who_responsible"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
import BuyerSellerSplit from '../buyer-seller-split.vue';
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    components: {
        BuyerSellerSplit,
    },

    props: {
        read_only: { default: false },
        commercial: {},
    },

    data() {
        return {
            has_filtration_pond: this.commercial.has_filtration_pond,
        }
    },
}
</script>
